import { SOrganGroup } from '@lp/features/Scheduler/SchedulerSurgeons/types';
import { OrganType } from '@/api/apis/case';
import { SShiftType } from '@/api/apis/resources/schedule';
import { getNameValuesFromEnumNames } from '@/utils/helpers';
import { NameByValue } from '@/types';

export const singleSShiftTypes = [SShiftType.OnCall];

export const regionRelatedSShiftTypes = [SShiftType.OnCall];

export const organGroupToOrgans = {
  [SOrganGroup.Liver]: [OrganType.Liver],
  [SOrganGroup.HeartAndLungs]: [OrganType.Heart, OrganType.Lungs],
};

export const organGroupNames = {
  [SOrganGroup.Liver]: 'Liver',
  [SOrganGroup.HeartAndLungs]: 'Heart & Lungs',
};

export const sShiftTypeNames: Record<SShiftType, string> = {
  [SShiftType.NoCall]: 'No Call',
  [SShiftType.OnCall]: 'On Call',
  [SShiftType.Sick]: 'Sick Leave',
  [SShiftType.Unavailable]: 'Unavailable',
  [SShiftType.Vacation]: 'Vacation',
};

export const sShiftTypeDropdownItems = [SShiftType.OnCall, SShiftType.NoCall, SShiftType.Unavailable, SShiftType.Sick];

export const S_SHIFT_TYPE_SELECT_LIST = getNameValuesFromEnumNames(sShiftTypeNames);
export const S_SHIFT_TYPE_DROPDOWN_LIST: NameByValue<SShiftType>[] = sShiftTypeDropdownItems.map((shiftType) => {
  return {
    value: shiftType,
    name: sShiftTypeNames[shiftType],
  };
});

export const sConflictsDrawerData = [
  { label: 'BY USER', accessorKey: 'resourcesMessagesList' } as const,
  { label: 'BY REGION', accessorKey: 'regionsMessagesList' } as const,
];
